import { ViewDocumentDetailsMetadata } from '../store/signature-popup.store';
import { SignatureRow } from '../types/signature-row.types';

export const toViewDocumentDetailsMetadata = (
  signature: SignatureRow,
): ViewDocumentDetailsMetadata => ({
  category: signature.category,
  companyId: signature.companyId,
  expirationPeriod: signature.expirationPeriod ?? null,
  linkedEventLabel: signature.linkedEventLabel ?? undefined,
  linkedTargetId: signature.linkedTargetId ?? undefined,
  name: signature.name,
  signatories: signature.signatories ?? [],
  subCategory: signature.subCategory,
});
